import React, { useState, useEffect } from "react";

import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
  
  Autocomplete,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Error } from "@material-ui/icons";

const useStyles = makeStyles(dashboardStyle);

const ProvinceModal = ({
   setOpen, 
  open,
  formState ,
  setFormState
 
}) => {
  const classes = useStyles();
  

const [provinceState ,  setProvinceState] = useState("")
const [errorMessage , setErrorMessage] = useState("")


  const getStampDuty = async (
    province
  ) => {
    await axios({
      method : "get", 
      url : `${process.env.REACT_APP_API_URL}/api/Invoices/stamp-duty?referenceText=${province}`,
      headers: {
        Authorization : `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type" : "application/json",
      },
    })
    .then(async (res) => {



        const updatedData = [...formState?.provinceDuty]

    updatedData[0] = {
        ...updatedData[0],
        province : provinceState,
        stampDutyRate : res.data
    }

    setFormState({
      ...formState,
      provinceDuty : updatedData
    })
     
      
      setOpen(false)

      console.log(res, "response of stamp duty")
      
    })
  }
const handleClose = () => {

  if(provinceState === "" || provinceState === null){
setErrorMessage("Please select Province")
  return
  }
  // setOpen(false)
else {
    setErrorMessage("")

  getStampDuty(provinceState)
}

  
}
  const changeHandler = (name , value) => {
   
    // setFormState((formState) => ({
    //   ...formState,
    //   [name]: value,
    // }));

    if(value !== "" || value !== null){
      setErrorMessage("")
    }

    setProvinceState(value)
  };

  console.log(formState, "formState")


  const validProvinces = ["Punjab", "Sindh"]
  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      
        <DialogTitle>
          <Typography>Select Province</Typography>
        </DialogTitle>
        <DialogContent>
        

                      <Autocomplete
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "30px",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiInputBase-input": {
                            marginTop: "-4px", // Adjust this value to move the text up
                            fontSize: 15,
                          },
                        }}
                        id="month"
                        options={validProvinces}
                        // classes={{ option: classes.option }}
                        size="small"
                        name="year"
                        // value={formState?.maturityPeriod || ""}
                     getOptionLabel={(option) => option.toString()}

                        // loading={vendorLoading}
                        onChange={(event, newValue) => {
                          console.log(newValue, "new Value")
                          changeHandler("year", newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            // sx={{ input: { color: "#888888" } }}
                            {...params}
                            name=""
                            required
                            value={""}
                            // onChange={changeHandler}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />   


                     {errorMessage && 
                     
                     
                        <Grid container spacing={0}>
                                    <Grid item>
                                      <Error
                                        titleAccess="Error"
                                     style={{color:"red"}}
                                        fontSize="small"
                                      />{" "}
                                    </Grid>
                                    <Grid item>
                                      <Typography style={{color:"red"}} ml={1}>
                                        {" "}
                                        {errorMessage}
                                      </Typography>
                                    </Grid>
                                  </Grid>}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={handleClose}>
            OK
          </Button>
        
        </DialogActions>
     
    </Dialog>
  );
};

export default ProvinceModal;
